import GridContainer from '@feature/GridContainer'
import { GridContainerProps } from '@feature/GridContainer/GridContainer'
import GridItem from '@feature/GridItem'
import { GridItemProps } from '@feature/GridItem/GridItem'
import Product from '@feature/Product'
import { ProductProps } from '@feature/Product/Product'
import TermLink from '@feature/TermLink'
import { Typography } from '@mui/material'
import { relatedProductsSearchQuery } from 'app/selectors'
import useProducts from 'helpers/useProducts'
import React from 'react'
import { TermIdentifier } from 'types'

export type RelatedProductsProps = GridContainerProps & {
  productId: number
  term: TermIdentifier
  size?: number
  title?: string
  hideTitle?: boolean
  hideCta?: boolean
  GridItemProps?: Partial<GridItemProps>
  ProductProps?: Partial<ProductProps>
}

const RelatedProducts = ({
  productId,
  term,
  size = 3,
  title,
  hideTitle,
  hideCta,
  ProductProps,
  GridItemProps,
  ...props
}: RelatedProductsProps) => {
  // const termUri = useSelector(hideCta ? noSelector(null) : getSelectTermUri(term.taxonomyId, term.slug || term.id))
  const { products } = useProducts(relatedProductsSearchQuery(productId, term, size))

  return !products.length ? (
    <></>
  ) : (
    <GridContainer justifyContent="center" textAlign="center" rowSpacing={4} {...props}>
      <GridItem xs={12}>{!hideTitle && <Typography variant="h3">{title || `More ${term.name} Products`}</Typography>}</GridItem>

      {products.map((p, i) => (
        <GridItem key={i} xs={12} sm={4} {...GridItemProps}>
          <Product key={i} entity={p} {...ProductProps} />
        </GridItem>
      ))}

      {!hideCta && (
        <GridItem xs={12}>
          <TermLink term={term} useButton>
            {'View All'}
          </TermLink>
        </GridItem>
      )}
    </GridContainer>
  )
}

export default RelatedProducts
